import { render, staticRenderFns } from "./Performances.vue?vue&type=template&id=07e24938"
import script from "./Performances.vue?vue&type=script&setup=true&lang=js"
export * from "./Performances.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Performances.vue?vue&type=style&index=0&id=07e24938&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports